import React, { useState, useEffect } from "react";
import {
  signInWithEmailAndPassword,
  onAuthStateChanged,
} from "firebase/auth";
import { doc, setDoc, getDoc } from "firebase/firestore";
import { auth, db } from "./firebase";
import { useNavigate } from "react-router-dom";
import { createUserWithEmailAndPassword } from "firebase/auth";

function generateToken(length = 10) {
  const chars =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let result = "";

  for (let i = 0; i < length; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }

  return result;
}

function LoginForm({ onLogin }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isRegistering, setIsRegistering] = useState(false);
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");
  const navigate = useNavigate();

const handleSubmit = async (e) => {
  e.preventDefault();
  setError("");
  setMessage("");

  try {
    if (isRegistering) {
      // 🔹 Create user
      const userCredential = await createUserWithEmailAndPassword(
        auth,
        email,
        password
      );

      const user = userCredential.user;

      const parentRef = doc(db, "parents", user.uid);
      const parentSnap = await getDoc(parentRef);

      if (!parentSnap.exists()) {
        await setDoc(parentRef, {
          parentName: "",
          parentEmail: user.email || email,
          parentPhone: "",
          childName: "",
          publicToken: generateToken(),
          hasAccess: false,
          createdAt: new Date().toISOString(),
        });
      }

      setMessage("Account created successfully.");
      onLogin();
      navigate("/edit");
    } else {
      // 🔹 Login
      await signInWithEmailAndPassword(auth, email, password);
      onLogin();
      navigate("/edit");
    }
  } catch (err) {
    setError(err.message);
  }
};

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user && user.email === "susannahldorrance@gmail.com") {
        navigate("/admin-qr");
      }
    });
    return () => unsubscribe();
  }, [navigate]);

  return (
    <div className="portal-page">
      <img
        src={`${process.env.PUBLIC_URL}/pink-collective-logo.png`}
        alt="The Pink Collective logo"
        className="portal-logo"
      />

      <div className="portal-card">
        <h1 className="portal-title">
          {isRegistering ? "Create Account" : "Parent Portal Login"}
        </h1>
        <div className="portal-underline" />

        <p className="portal-text">
          {isRegistering
            ? "Create an account to get started."
            : "Log in to view or edit your parent portal information."}
        </p>

        <form onSubmit={handleSubmit} className="portal-form">
          <label className="portal-label">
            Email
            <input
              className="portal-input"
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </label>

          <label className="portal-label">
            Password
            <input
              className="portal-input"
              type="password"
              placeholder="Enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </label>

          <button type="submit" className="portal-button">
            {isRegistering ? "Sign Up" : "Login"}
          </button>

          <button
            type="button"
            className="portal-button portal-button-secondary portal-toggle-button"
            onClick={() => {
              setIsRegistering(!isRegistering);
              setError("");
              setMessage("");
            }}
          >
            {isRegistering
              ? "Already have an account? Log in"
              : "Need an account? Create one"}
          </button>
        </form>

        {message && (
          <p className="portal-message success-message">{message}</p>
        )}
        {error && <p className="portal-message error-message">{error}</p>}
      </div>
    </div>
  );
}

export default LoginForm;